import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
    useTab,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_APRVAPP_DTL } from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import {
    APIS as IQS_APIS,
    URLS as IQS_URLS,
    getIqsAccessData,
} from "@/tz/go/egaz/osci/ptl/mypg/iqs/services/OsciMypgIqsService";
import { APP_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_GEN";
import { APP_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_TRPT";
import { APP_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_INVC";
import { APP_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ITM";
import { APP_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ATCM";
import { APP_DTL_PAY_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_PAY_INFO";
import { APP_DTL_MSG } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_MSG";
import { APP_DTL_DCLR } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_DCLR";
import { APIS_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppOfcrAddItmService";
import { CommonErrors } from "@/comn/components";

/**
 * LPCO Application Verification Detail
 * !== LPCO 신청서 심사 상세 ==!
 */
export const OSCI0201004S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId, back } = usePage({
        auth: ["auth_osci0006", "auth_osci0015"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { appId, appNo, appDgr } = useParams();

    const location = useLocation();
    const [param, setParam] = useState<any>({ ...(location.state ?? {}) });
    const menuTp = param?.menuTp || "VRFN";
    const prcsRoleTpCd = "VE"; // Screen processing role !== 화면 처리롤 ==!

    let tabSchemaList: any = [];

    const [visible, setVisible] = useState(false);
    const [rcveVisible, setRcveVisible] = useState(false);
    const [tansad, setTansadVisible] = useState(false);

    // Accessible IQS ID for IQS button !== IQS 버튼용 접근 가능 IQS ID ==!
    const [iqsId, setIqsId] = useState("");

    const [gnrl, setGnrlVisible] = useState(false);
    const [trpt, setTrptVisible] = useState(false);
    const [invc, setInvcVisible] = useState(false);
    const [itm, setItmVisible] = useState(false);
    const [atcm, setAtcmVisible] = useState(false);
    const [payInfo, setpayInfoVisible] = useState(false);
    const [msg, setMsgVisible] = useState(false);
    const [dclr, setDclrVisible] = useState(false);
    const [cfrm, setCfrmVisible] = useState(false);

    const [comnCdList, setComnCdList] = useState([]);

    // !== 2026-04-22 KNH: 추가 필드의 변경 여부를 판단할 상태 ==!
    const [ofcrAddItmChanged, setOfcrAddItmChanged] = useState(false);

    // !== 2026-04-22 KNH: 탭별 저장 함수 ==!
    const saveFnMapRef = useRef<Record<string, (() => Promise<boolean>) | undefined>>({});

    // !== 2026-04-22 KNH: 탭별 저장 함수 등록 ==!
    const registTabSave = (tabCd: string, fn?: () => Promise<boolean>) => {
        saveFnMapRef.current[tabCd] = fn;
    };

    // !== 2026-04-22 KNH: 탭별 필수값 검증 함수 ==!
    const validFnMapRef = useRef<Record<string, (() => Promise<boolean>) | undefined>>({});

    // !== 2026-04-22 KNH: 탭별 검증 함수 등록 ==!
    const registTabValid = (tabCd: string, fn?: () => Promise<boolean>) => {
        validFnMapRef.current[tabCd] = fn;
    };

    /*
     * Application Detail Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Application Ddtail Info Form !== 신청서 상세 정보 Form ==!
        newAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
            defaultValues: {
                // ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Pre-Application Tab
     * !== 탭 정의 ==!
     */
    const tab = {
        tabSchema: useTab({
            defaultSchema: {
                id: "tab",
                schema: tabSchemaList,
            },
        }),
    };

    const render = {
        tabView: () => {
            const tabPanelList: any = [];
            const tabList = comnCdList;
            if (tabList != undefined) {
                tabList.map((item: any) => {
                    if ("GEN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {gnrl && (
                                    <APP_DTL_GEN
                                        state={{ ...param, prcsRoleTpCd }}
                                        onOfcrAddItmChange={(changed: boolean) => setOfcrAddItmChanged(changed)}
                                        onRegisterTabSave={registTabSave}
                                        onRegisterTabValid={registTabValid}
                                    />
                                )}
                            </Tab.Panel>,
                        );
                    } else if ("TRN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {trpt && (
                                    <APP_DTL_TRPT
                                        state={{ ...param, prcsRoleTpCd }}
                                        onOfcrAddItmChange={(changed: boolean) => setOfcrAddItmChanged(changed)}
                                        onRegisterTabSave={registTabSave}
                                        onRegisterTabValid={registTabValid}
                                    />
                                )}
                            </Tab.Panel>,
                        );
                    } else if ("INV" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {invc && (
                                    <APP_DTL_INVC
                                        state={{ ...param, prcsRoleTpCd }}
                                        onOfcrAddItmChange={(changed: boolean) => setOfcrAddItmChanged(changed)}
                                        onRegisterTabSave={registTabSave}
                                        onRegisterTabValid={registTabValid}
                                    />
                                )}
                            </Tab.Panel>,
                        );
                    } else if ("ITM" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {itm && (
                                    <APP_DTL_ITM
                                        state={{ ...param, prcsRoleTpCd }}
                                        onOfcrAddItmChange={(changed: boolean) => setOfcrAddItmChanged(changed)}
                                        onRegisterTabSave={registTabSave}
                                        onRegisterTabValid={registTabValid}
                                        ofcrAddItmChanged={ofcrAddItmChanged}
                                    />
                                )}
                            </Tab.Panel>,
                        );
                    } else if ("ATC" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{atcm && <APP_DTL_ATCM state={param} />}</Tab.Panel>,
                        );
                    } else if ("PAY" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{payInfo && <APP_DTL_PAY_INFO state={param} />}</Tab.Panel>,
                        );
                    } else if ("MSG" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{msg && <APP_DTL_MSG state={param} />}</Tab.Panel>,
                        );
                    } else if ("DCL" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>{dclr && <APP_DTL_DCLR state={param} />}</Tab.Panel>,
                        );
                    }
                });
            }
            return tabPanelList;
        },
    };

    /*
     * Master Applidation Details Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppInfo: useFetch({
            api: (appId) => APIS.getAppInfo({ appId: appId, orgCd: auth.get("orgCd") }),
            onSuccess: (data) => {
                const content = data?.appInfo?.content ?? {};

                console.log("getAppInfo", content);

                form.newAppDtl.setValues({ ...content });

                if (content.cstmOfceCd && content.tansadYy && content.tansadSrno) {
                    setTansadVisible(true);
                }

                // Check IQS only for applications not yet completed (AP/RJ/CL) !== 처리 완료(AP/RJ/CL) 전 신청서만 IQS 확인 ==!
                if (content.appStatCd !== "AP" && content.appStatCd !== "RJ" && content.appStatCd !== "CL") {
                    fetch.getIqsId.fetch(content.appId);
                }

                let edit = false;

                if (content) {
                    const asnmtCfrmDtm = content.asnmtCfrmDtm;
                    const ofcrPrcssDtm = content.ofcrPrcssDtm;

                    setRcveVisible(!asnmtCfrmDtm);

                    if (asnmtCfrmDtm && !ofcrPrcssDtm && menuId !== "elecAprv") {
                        setVisible(true);
                        // !== 2026-04-22 KNH: 추가 필드의 Editing 여부 설정 ==!
                        // !== @TOBE KNH: 현재 심사 단계이며, 심사자가 접수한 경우 수정할 수 있게 함 ==!
                        // if (location.state.prcsRoleTpCd == "VE") {
                        edit = true;
                        // }
                    }
                }

                setParam({ ...content, edit: edit });

                handler.getTabSchemaList(content);
            },
            onError: (error) => {},
        }),
        // TODO 나의할일 관련 메소드 추가
        getAppInfoToAppNo: useFetch({
            api: (appNo, appDgr) => APIS.getAppInfoToAppNo({ appNo: appNo, appDgr: appDgr, orgCd: auth.get("orgCd") }),
            onSuccess: (data) => {
                const content = data?.appInfo?.content ?? {};

                console.log("getAppInfo", content);

                form.newAppDtl.setValues({ ...content });

                if (content.cstmOfceCd && content.tansadYy && content.tansadSrno) {
                    setTansadVisible(true);
                }

                // Check IQS only for applications not yet completed (AP/RJ/CL) !== 처리 완료(AP/RJ/CL) 전 신청서만 IQS 확인 ==!
                if (content.appStatCd !== "AP" && content.appStatCd !== "RJ" && content.appStatCd !== "CL") {
                    fetch.getIqsId.fetch(content.appId);
                }

                let edit = false;

                if (content) {
                    const asnmtCfrmDtm = content.asnmtCfrmDtm;
                    const ofcrPrcssDtm = content.ofcrPrcssDtm;

                    setRcveVisible(!asnmtCfrmDtm);

                    if (asnmtCfrmDtm && !ofcrPrcssDtm && menuId !== "elecAprv") {
                        setVisible(true);
                        // !== 2026-04-22 KNH: 추가 필드의 Editing 여부 설정 ==!
                        // !== @TOBE KNH: 현재 심사 단계이며, 심사자가 접수한 경우 수정할 수 있게 함 ==!
                        // if (location.state.prcsRoleTpCd == "VE") {
                        edit = true;
                        // }
                    }
                }

                setParam({ ...content, edit: edit });

                handler.getTabSchemaList(content);
            },
            onError: (error) => {},
        }),

        // Get the accessible IQS ID !== 접근 가능한 IQS ID 조회 ==!
        getIqsId: useFetch({
            api: (appId) => IQS_APIS.getIqsIdByBsopId(appId, getIqsAccessData(auth)),
            onSuccess: (data) => {
                setIqsId(data?.iqsId?.content ?? "");
            },
            onError: (error) => {},
        }),

        getRprt: useFetch({
            api: () => {
                return lpcoUtils.getRprtLpco(
                    appId || param.appId, // Route appId is absent on the /:appNo/:appDgr (My Task) path !== 나의 할일 경로엔 라우트 appId가 없어 state 값으로 대체 ==!
                    // ["AP", "CL"].indexOf(form.newAppDtl.getValue("appStatCd")) > -1 ? "N" : "Y",
                    "Y",
                );
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        getRprtHlthCrte: useFetch({
            api: () => {
                return lpcoUtils.getRprtHlthCrte(
                    appId || param.appId, // Route appId is absent on the /:appNo/:appDgr (My Task) path !== 나의 할일 경로엔 라우트 appId가 없어 state 값으로 대체 ==!
                    // ["AP", "CL"].indexOf(form.newAppDtl.getValue("appStatCd")) > -1 ? "N" : "Y",
                    "N",
                );
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: useFetch({
            api: (appId, appStatCd) => {
                return APIS.updateReceived(appId, appStatCd);
            },
            onSuccess: (data, param) => {
                handler.setInit();
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
        }),
        // Check required additional item input !== 필수 추가 필드 입력 여부 조회 ==!
        checkOfcrAdtnlItmRqrd: useFetch({
            api: (appId: string, prcsRoleTpCd?: string) => APIS_ADD_ITM.checkOfcrAdtnlItmRqrd(appId, prcsRoleTpCd),
            onSuccess: (data: any) => {
                console.log("data", data);
                return data;
            },
            onError: (error: any) => {
                console.log("error", error);
                return { valid: false, missingCount: 0, missingList: [] };
            },
        }),
        // Get process information to check the configuration !== 프로세스 설정 확인용 정보 조회 ==!
        checkPrcsCfgn: useFetch({
            api: (appId: string) => APIS.getAppAprvInfo({ reffId: appId }),
            onError: (error: any) => {
                console.log("checkPrcsCfgn error", error);
            },
        }),
    };

    /*
     * Application Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            // TODO 나의할일 관련 메소드 변경
            if (appId !== null && appId !== "" && appId !== undefined) {
                await handler.getAppInfo(appId);
            } else if (appNo !== null && appNo !== "" && appNo !== undefined) {
                await handler.getAppInfoToAppNo(appNo, appDgr);
            }
            render.tabView();
        },
        // Get Pre-Application Information !== 사전신청서 정보 조회 ==!
        getAppInfo: async (appId: any) => {
            return fetch.getAppInfo.fetch(appId);
        },
        // Get Pre-Application Information !== 사전신청서 정보 조회 ==!
        getAppInfoToAppNo: async (appNo: any, appDgr: any) => {
            return fetch.getAppInfoToAppNo.fetch(appNo, appDgr);
        },
        getTabSchemaList: async (data: any) => {
            const reqParam = { orgCd: data.orgCd, appCdNo: data.appCdNo, appTpCd: data.appTpCd };
            const comnCdList = await lpcoUtils.getCpntList(reqParam);
            comnCdList.map((item: any) => {
                if ("CON" != item.value) {
                    tabSchemaList.push({ label: item.label });
                }
            });
            tab.tabSchema.setSchema(tabSchemaList);
            setComnCdList(comnCdList);

            handler.changeTab(0);
        },
        // Hide existing tab contents when changing tab !== Tab변경 시 기존 탭 내용 숨김처리  ==!
        chanageTabVisible: () => {
            setGnrlVisible(false);
            setTrptVisible(false);
            setInvcVisible(false);
            setItmVisible(false);
            setAtcmVisible(false);
            setCfrmVisible(false);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        changeTab: async (index: any) => {
            handler.chanageTabVisible();
            let tabList = comnCdList;
            if (tabList && tabList.length > 0) {
                const tabInfo: any = tabList[index];
                switch (tabInfo.value) {
                    case "GEN":
                        setGnrlVisible(true);
                        break;
                    case "TRN":
                        setTrptVisible(true);
                        break;
                    case "INV":
                        setInvcVisible(true);
                        break;
                    case "ITM":
                        setItmVisible(true);
                        break;
                    case "ATC":
                        setAtcmVisible(true);
                        break;
                    case "PAY":
                        setpayInfoVisible(true);
                        break;
                    case "MSG":
                        setMsgVisible(true);
                        break;
                    case "DCL":
                        setDclrVisible(true);
                        break;
                    // case "CON":
                    //     setCfrmVisible(true);
                    //     break;
                }
            }
            tab.tabSchema.setActive(index);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        openRgstRsltModal: async (menuTp: any) => {
            console.log("openRgstRsltModal");
            console.log("ofcrAddItmChanged", ofcrAddItmChanged);
            // !== 2026-04-22 KNH: 추가 필드의 변경 여부 확인인 ==!
            if (ofcrAddItmChanged) {
                modal.openModal({ content: "msg.osc.00144" }); // Unsaved data exists. Save first and then try again. !== 저장하지 않은 데이터가 존재합니다. 먼저, 저장하고 다시 시도해주시기 바랍니다. ==!
                return;
            }

            // Block when the current step is missing in the process configuration !== 현재 처리단계가 프로세스 설정에 없으면 차단 ==!
            if (!(await handler.checkPrcsCfgnValid(appId || param.appId))) {
                return;
            }

            // !== 2026-04-22 KNH: 현재 탭의 저장 여부 와 모든 탭의 필수값 검증 ==!
            // const valid = await handler.validAllTab();
            // console.log("valid", valid);
            // if (!valid) {
            //     modal.openModal({content: "msg.osc.00195"}); // TODO KNH: 오류 메시지 변경 필요
            //     return;
            // }

            // Validate required officer additional items across all tabs !== 전체 탭의 필수 담당자 추가항목 미입력 검증 ==!
            const { valid, missingList, error } = await handler.checkOfcrAdtnlItmRqrd();
            if (error) {
                modal.openModal({ content: "msg.osc.00015" }); // Error while processing !== 처리 중 오류 ==!
                return;
            }
            if (!valid) {
                // Show missing items as a list and do not open the review-result popup !== 미입력 항목을 목록으로 안내하고 심사결과 팝업은 열지 않음 ==!
                modal.openModal({
                    content: <CommonErrors errors={missingList} type="messages" />,
                    size: "lg",
                    draggable: true,
                });
                return;
            }

            modal.openModal({
                // url 로 팝업창의 주소를 기입
                url: URLS.osci0201005s,
                // 팝업창에 보낼 파라메터 정의
                params: { appInfo: { ...form.newAppDtl.getValues() } },
                size: "md",
                draggable: true,
                // 팝업창에서 modal.postMessage 메소드 실행시 callback 함수
                callback: (data) => {
                    if (data != null && data != "") {
                        if (data.rslt == "save") {
                            handler.setInit();
                        } else if (data.rslt == "sbmt") {
                            modal.closeModal();
                            if (menuId === "mytodo") {
                                back();
                            } else {
                                navigate(URLS.osci0201003q);
                            }
                        }
                    }
                },
            });
        },
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: async (appId: any, appStatCd: any) => {
            if (!(await handler.checkPrcsCfgnValid(appId))) {
                return;
            }
            fetch.updateReceived.fetch(appId, appStatCd);
        },
        // Save current tab !== 현재 탭 저장 ==!
        saveCurrentTab: async () => {
            const activeIndex = tab.tabSchema.getActive();
            const activeTabCd = (comnCdList as any[])?.[activeIndex]?.value; // GEN, TRN...
            console.log("activeTabCd", activeTabCd);
            const saveFn = activeTabCd ? saveFnMapRef.current[activeTabCd] : undefined;

            if (!saveFn) {
                modal.openModal({ content: "msg.osc.00018" }); // 저장 대상 없음(예시)
                return;
            }

            const success = await saveFn();
            console.log("success", success);
            if (success) {
                setOfcrAddItmChanged(false);
                toast.showToast({ content: "msg.osc.00073" }); // Successfully saved. !== 정상적으로 저장되었습니다. ==!
            }
        },
        // Block when the current step is missing in the process configuration !== 현재 처리단계가 프로세스 설정에 없으면 차단 ==!
        checkPrcsCfgnValid: async (appId: any): Promise<boolean> => {
            const result: any = await fetch.checkPrcsCfgn.fetch(appId);
            if (result?.prcsInfo?.content?.prcsRoleTpCd) {
                return true;
            }
            modal.openModal({ content: "msg.osc.00046" }); // Process setting error, contact the organization !== 프로세스 설정 오류, 기관 문의 ==!
            return false;
        },
        // Check required additional item input !== 필수 추가항목 입력 여부 조회 ==!
        checkOfcrAdtnlItmRqrd: async (): Promise<{ valid: boolean; missingList: any[]; error: boolean }> => {
            // Fall back to state appId for the /:appNo/:appDgr route (My Task) !== 나의 할일 경로(:appNo/:appDgr)에선 라우트 appId가 없어 state 값으로 대체 ==!
            const rsltAppId = appId || param.appId;
            if (!rsltAppId) {
                modal.openModal({ content: "msg.osc.00147" }); // Missing appId !== appId 누락 ==!
                return { valid: false, missingList: [], error: true };
            }

            try {
                const result: any = await fetch.checkOfcrAdtnlItmRqrd.fetch(rsltAppId, prcsRoleTpCd);

                // Guard against HTTP error response !== HTTP 오류 응답 방어 ==!
                if (result?.response) {
                    return { valid: false, missingList: [], error: true };
                }

                // Unwrap ResponseHelper content wrapper !== ResponseHelper content 래핑 해제 ==!
                const missingList: any[] = result?.missingList?.content ?? result?.missingList ?? [];
                const validFlag = result?.valid?.content ?? result?.valid;
                const valid = validFlag === true && missingList.length === 0;

                return { valid, missingList, error: false };
            } catch (e) {
                // Treat unexpected failure as invalid to block the popup !== 예외는 실패로 처리해 팝업 진입 차단 ==!
                console.log("checkOfcrAdtnlItmRqrd error", e);
                return { valid: false, missingList: [], error: true };
            }
        },
        // !== 2026-04-22 KNH: 모든 탭의 필수값 검증 ==!
        validAllTab: async () => {
            let allValid = true;

            const fns = Object.values(validFnMapRef.current);
            for (const validFn of fns) {
                // 함수가 없으면 스킵(필요하면 false 처리로 바꿔도 됨)
                if (!validFn) continue;

                const isValid = await validFn(); // 순차 실행
                if (!isValid) {
                    allValid = false;
                    break;
                }
            }

            return allValid;
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        if (comnCdList && comnCdList.length > 0) {
            handler.changeTab(0);
        }
    }, [comnCdList]);

    useEffect(() => {
        setParam({ ...(location.state ?? {}) });
    }, [location.state]);

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: "L_CO_LCNE" }, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNo} />
                            <Group.Control {...form.newAppDtl.schema.ucrNo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appNm} />
                            <Group.Control {...form.newAppDtl.schema.appTpNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.sbmtDtm} />
                            <Group.Control {...form.newAppDtl.schema.aprvDtm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.appStatNm} />
                            <Group.Control {...form.newAppDtl.schema.appXpirDt} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppDtl.schema.nregYn} />
                            <Group.Label {...form.newAppDtl.schema.tansadNo} />
                            {tansad && (
                                <Group.Field
                                    as="link"
                                    onClick={() => {
                                        modal.openModal({
                                            url: `${lpcoEnvs.base}/lpco/tansad/osci0202002q/${form.newAppDtl.getValue(
                                                "cstmOfceCd",
                                            )}-${form.newAppDtl.getValue("tansadYy")}-${form.newAppDtl.getValue(
                                                "tansadSrno",
                                            )}`,
                                            draggable: true,
                                            callback: (data) => {
                                                modal.closeModal();
                                            },
                                        });
                                    }}
                                >
                                    <Group.Control {...form.newAppDtl.schema.cstmOfceCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.newAppDtl.schema.tansadYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.newAppDtl.schema.tansadSrno} />
                                </Group.Field>
                            )}
                            {!tansad && <Group.Field />}
                        </Group.Row>
                        {!!form.newAppDtl.getValue("audtOpinCn") && (
                            <Group.Row>
                                <Group.Control {...form.newAppDtl.schema.audtOpinCn} controlSize={10} />
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    if (menuId === "mytodo") {
                                        back();
                                    } else {
                                        navigate(URLS.osci0201003q);
                                    }
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {/* <Button
                                variant="secondary"
                                onClick={() => {
                                    fetch.getRprtHlthCrte.fetch();
                                }}
                            >
                                {t("B_PRNT")}
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    fetch.getRprt.fetch();
                                }}
                            >
                                {t("B_PRNT")}
                            </Button> */}
                            {iqsId && (
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        modal.openModal({
                                            url: `${IQS_URLS.osci0102003s}/${iqsId}`,
                                            size: "md",
                                            draggable: true,
                                            callback: (data) => {
                                                modal.closeModal();
                                            },
                                        });
                                    }}
                                >
                                    {t("B_IQS")}
                                </Button>
                            )}
                            {visible && (
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        handler.openRgstRsltModal(menuTp);
                                    }}
                                >
                                    {t("B_RGST_VRFN_RSLT")}
                                </Button>
                            )}
                            {rcveVisible && (
                                <Button
                                    type="button"
                                    color="success"
                                    onClick={() => {
                                        handler.updateReceived(param.appId, param.appStatCd);
                                    }}
                                >
                                    {t("L_RCVE_1")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab
                        {...tab.tabSchema.tab}
                        onChange={(index) => {
                            // !== 2026-04-22 KNH: 다른 탭을 눌렀는데 현재 정보가 변경되었을 경우 저장하라는 메시지 표시 ==!
                            const activeIndex = tab.tabSchema.getActive();
                            if (activeIndex !== index && ofcrAddItmChanged) {
                                modal.openModal({ content: "msg.osc.00144" }); // Unsaved data exists. Save first and then try again. !== 저장하지 않은 데이터가 존재합니다. 먼저, 저장하고 다시 시도해주시기 바랍니다. ==!
                                return false;
                            }

                            // 탭이 변경되었을때 index 번호와 onChange 이벤트를 호출
                            handler.changeTab(index);
                        }}
                    >
                        {render.tabView()}
                    </Tab>
                </Group.Body>
            </Group>
            {visible && (
                <Layout direction="row">
                    <Layout.Left />
                    <Layout.Right>
                        <Button variant="primary" onClick={handler.saveCurrentTab} disabled={!ofcrAddItmChanged}>
                            {t("B_SAVE")}
                        </Button>
                    </Layout.Right>
                </Layout>
            )}
        </Page>
    );
};
